module.exports = __webpack_public_path__ + "img/logo.50d27770.png";